<template>
    <NotificationGroup group="error">
        <div
            class="fixed top-0 right-0 z-[7020] flex h-0 w-full max-w-full items-start justify-end p-2 select-none sm:max-w-sm"
        >
            <div class="w-full max-w-full sm:max-w-sm">
                <Notification
                    v-slot="{ notifications, close }"
                    enter="transform ease-out duration-300 transition"
                    enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                    enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-500"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                    move="transition duration-500"
                    move-delay="delay-300"
                >
                    <div
                        v-for="notification in notifications"
                        :key="notification.id"
                        class="relative mx-auto mt-4 flex w-full max-w-sm overflow-hidden rounded-lg border border-red-400 bg-red-500 shadow-md"
                    >
                        <div class="flex items-center justify-center pl-4">
                            <MdiAlertCircle class="h-7 w-7 text-white" />
                        </div>

                        <div class="mr-10 py-1 pl-4">
                            <span class="font-semibold text-white">{{ notification.title }}</span>
                            <p class="text-sm text-white">
                                {{ notification.text }}
                            </p>
                        </div>

                        <button
                            class="absolute top-1 right-0 z-[7021] cursor-pointer px-1 pt-1"
                            @click="close(notification.id)"
                        >
                            <MdiClose class="mx-1 h-5 w-5 text-white" />
                        </button>
                    </div>
                </Notification>
            </div>
        </div>
    </NotificationGroup>

    <NotificationGroup group="warning">
        <div
            class="fixed top-0 right-0 z-[7020] flex h-0 w-full max-w-full items-start justify-end p-2 select-none sm:max-w-sm"
        >
            <div class="w-full max-w-full sm:max-w-sm">
                <Notification
                    v-slot="{ notifications, close }"
                    enter="transform ease-out duration-300 transition"
                    enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                    enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-500"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                    move="transition duration-500"
                    move-delay="delay-300"
                >
                    <div
                        v-for="notification in notifications"
                        :key="notification.id"
                        class="relative mx-auto mt-4 flex w-full max-w-sm overflow-hidden rounded-lg border border-amber-400 bg-amber-500 shadow-md"
                    >
                        <div class="flex items-center justify-center pl-4">
                            <MdiAlertCircle class="h-7 w-7 text-white" />
                        </div>

                        <div class="mr-10 py-1 pl-4">
                            <span class="font-semibold text-white">{{ notification.title }}</span>
                            <p class="text-sm text-white">
                                {{ notification.text }}
                            </p>
                        </div>

                        <button
                            class="absolute top-1 right-0 z-[7021] cursor-pointer px-1 pt-1"
                            @click="close(notification.id)"
                        >
                            <MdiClose class="mx-1 ml-2 h-5 w-5 text-white" />
                        </button>
                    </div>
                </Notification>
            </div>
        </div>
    </NotificationGroup>

    <NotificationGroup group="success">
        <div
            class="fixed top-0 right-0 z-[7020] flex h-0 w-full max-w-full items-start justify-end p-2 select-none sm:max-w-sm"
        >
            <div class="w-full max-w-full sm:max-w-sm">
                <Notification
                    v-slot="{ notifications, close }"
                    enter="transform ease-out duration-300 transition"
                    enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                    enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-500"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                    move="transition duration-500"
                    move-delay="delay-300"
                >
                    <div
                        v-for="notification in notifications"
                        :key="notification.id"
                        class="relative mx-auto mt-4 flex w-full max-w-sm overflow-hidden rounded-lg border border-emerald-400 bg-emerald-500 shadow-md"
                    >
                        <div class="flex items-center justify-center pl-4">
                            <MdiInformation class="h-7 w-7 text-white" />
                        </div>

                        <div class="mr-10 py-1 pl-4">
                            <span class="font-semibold text-white">{{ notification.title }}</span>
                            <p class="text-sm text-white">
                                {{ notification.text }}
                            </p>
                        </div>

                        <button
                            class="absolute top-1 right-0 z-[7021] cursor-pointer px-1 pt-1"
                            @click="close(notification.id)"
                        >
                            <MdiClose class="mx-1 h-5 w-5 text-white" />
                        </button>
                    </div>
                </Notification>
            </div>
        </div>
    </NotificationGroup>

    <NotificationGroup group="info">
        <div
            class="fixed top-0 right-0 z-[7020] flex h-0 w-full max-w-full items-start justify-end p-2 select-none sm:max-w-sm"
        >
            <div class="w-full max-w-full sm:max-w-sm">
                <Notification
                    v-slot="{ notifications, close }"
                    enter="transform ease-out duration-300 transition"
                    enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                    enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-500"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                    move="transition duration-500"
                    move-delay="delay-300"
                >
                    <div
                        v-for="notification in notifications"
                        :key="notification.id"
                        class="relative mx-auto mt-4 flex w-full max-w-sm overflow-hidden rounded-lg border border-blue-400 bg-blue-500 shadow-md"
                    >
                        <div class="flex items-center justify-center pl-4">
                            <MdiInformation class="h-7 w-7 text-white" />
                        </div>

                        <div class="mr-10 py-1 pl-4">
                            <span class="font-semibold text-white">{{ notification.title }}</span>
                            <p class="text-sm text-white">
                                {{ notification.text }}
                            </p>
                        </div>

                        <button
                            class="absolute top-1 right-0 z-[7021] cursor-pointer px-1 pt-1"
                            @click="close(notification.id)"
                        >
                            <MdiClose class="mx-1 h-5 w-5 text-white" />
                        </button>
                    </div>
                </Notification>
            </div>
        </div>
    </NotificationGroup>
</template>

<script setup>
    import { MdiAlertCircle, MdiInformation, MdiClose } from 'materialdesignicons-vue3/icons/';
</script>
